import React, { useEffect, useState, useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import FormTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import PopoverDialog from '../../../Popup/PopoverDialog';
import ModalDialog from '../../../Popup/ModalDialog';
import GroupsList from '../../../AddToGroupsPanel/_partials/GroupsList';
import { useAddToGroupFlow } from '../../../AddToGroupsPanel/useAddToGroupFlow';
import SelectedGroupHeader from './SelectedGroupHeader';
import { FolderType, } from '../../../AddToGroupsPanel/redux/types';
import FolderList from '../../../AddToGroupsPanel/_partials/FolderList';
import s from './AddToGroupPopup.scss';
var AddToGroupPopover = function (_a) {
    var deviation = _a.deviation, className = _a.className, actionbarType = _a.actionbarType, initGroupsPanel = _a.initGroupsPanel, addToGroupFolder = _a.addToGroupFolder, hasOnlyOneChunkOfGroupsToLoad = _a.hasOnlyOneChunkOfGroupsToLoad, hasNoGroups = _a.hasNoGroups, onClose = _a.onClose;
    var t = useTranslation().t;
    var setInputRef = useBiClickLogger({
        evid: BiEventType.DEFAULT,
        click_info: 'addToGroup.searchGroup',
    }).setTrackingRef;
    var isMobile = useContext(MobileContext);
    var _b = useState(''), filterValue = _b[0], setFilterValue = _b[1];
    var _c = useAddToGroupFlow(), selectGroup = _c.selectGroup, selectedGroup = _c.selectedGroup, resetSelectedGroup = _c.resetSelectedGroup, selectedSubmissionType = _c.selectedSubmissionType, selectSubmissionType = _c.selectSubmissionType;
    useEffect(function () {
        initGroupsPanel();
    }, [initGroupsPanel]);
    useEffect(function () {
        setFilterValue('');
    }, [selectedGroup]);
    var onFilterInputChange = function (e) { return setFilterValue(e.target.value); };
    var onFolderSelected = function (folderId) {
        addToGroupFolder(deviation, selectedGroup, {
            groupId: selectedGroup.userId,
            type: selectedSubmissionType,
            folderId: folderId,
        }, actionbarType);
        setTimeout(function () {
            onClose && onClose();
        }, 1000); // to show state change (folder becoming checked in the list) for the user
    };
    var tabs = [
        {
            index: FolderType.Gallery,
            label: t('addToGroup.folderType.gallery'),
        },
        {
            index: FolderType.Collection,
            label: t('addToGroup.folderType.collection'),
        },
    ];
    var PopupComponent = isMobile ? ModalDialog : PopoverDialog;
    return (React.createElement(PopupComponent, { isOpen: true, title: selectedGroup ? (React.createElement(SelectedGroupHeader, { group: selectedGroup, resetSelectedGroup: resetSelectedGroup })) : (t('addToGroupPopup.title')), headerExtras: React.createElement(React.Fragment, null,
            selectedGroup && (React.createElement(FormTabs, { items: tabs, activeIndex: selectedSubmissionType, onChange: selectSubmissionType, className: s['tabs'] })),
            !selectedGroup && !hasNoGroups && hasOnlyOneChunkOfGroupsToLoad && (React.createElement(TextInput, { ref: setInputRef, id: "search-input", className: s['filter-input'], label: t('addToGroupPopup.input.filter.placeholder'), placeholder: t('addToGroupPopup.input.filter.placeholder'), value: filterValue, onChange: onFilterInputChange, prefix: React.createElement(SearchIcon, { disableDefaultColors: true }), noBottomSpacing: true, isLabelHidden: true }))), className: !isMobile ? c(s['root'], className) : undefined, withScrollableContentWrapper: false, onClose: onClose },
        selectedGroup === undefined && (React.createElement(GroupsList, { filterValue: filterValue, onSelect: selectGroup })),
        selectedGroup && (React.createElement(FolderList, { deviationId: deviation.deviationId, groupId: selectedGroup.userId, submissionType: selectedSubmissionType, onFolderSelected: onFolderSelected }))));
};
AddToGroupPopover.displayName = 'AddToGroupPopover';
export default AddToGroupPopover;
//# sourceMappingURL=AddToGroupPopup.js.map